/** Classes for the avatar itself and the overlay that covers it on hover. */

const SHADOW = 'shadow-[0px_0px_7px_#718096]'

/** 125x125, which is what `profileImageSize` was. */
export const size = 'w-[125px] h-[125px]'

/** The box around the image. */
export const frame = (isRounded, noShadow, noBorder) => [
  size,
  'relative block',
  isRounded ? 'rounded-full' : (noShadow ? 'rounded-md' : 'rounded-none'),
  noBorder ? '' : 'border border-[var(--cck-border,#E2E8F0)] dark:border-[var(--cck-border-dark,rgba(255,255,255,0.16))]'
].join(' ')

export const avatar = noShadow => ['bg-transparent object-contain text-4xl', noShadow ? '' : SHADOW].join(' ')

export const image = noShadow => [
  'object-contain p-1',
  noShadow ? 'rounded-md' : `rounded-none ${SHADOW}`
].join(' ')

/**
 * The "change picture" layer.
 *
 * It used to be positioned with `top: -125px` on a sibling — i.e. pulled back up over the image
 * by exactly its own height. `absolute inset-0` says the same thing without depending on the
 * image being exactly 125px tall.
 */
export const overlay = (isRounded, noShadow) => [
  'absolute inset-0 flex justify-center items-center cursor-pointer',
  'transition-all duration-300 ease-[cubic-bezier(0.25,0.1,0.25,1)]',
  'hover:bg-black/70',
  'outline-2 outline-transparent outline-offset-2',
  'focus-visible:shadow-[0_0_0_3px_rgba(66,153,225,0.6)]',
  isRounded ? 'rounded-full' : (noShadow ? 'rounded-md' : 'rounded-none')
].join(' ')
